import React from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { Sorters } from "utils/tableUtils";
import EmailFormNew from "../TicketingToolModels/EmailFormNew";
import IntegrationsAPI from "restAPI/IntegrationsAPI";
import ArmorCodeApiForm from "../armorcodeApi/ArmorCodeApiForm";
import { ArmorCodeConfigTable } from "../Integrations";
import NotificationAPI from 'restAPI/NotificationAPI';
import JenkinsDashboard from "../jenkins/JenkinsDashboard";
import {GithubDashboardNew} from "../github/GithubDashboardNew";
// import ArmorCodeAgentForm from "../armorcodeAgent/ArmorCodeAgentForm";
import IngestionScriptFormPopup from "../IngestionScriptFormPopup";
import JenkinsFormPopup from "../jenkins/JenkinsFormPopup";
import GithubEnterpriseForm from "../github/GithubEnterpriseForm";
import { IntegrationType } from "../common";
import AquasecPullAndPushView from "../aquasec/AquasecPullAndPushView";
import SonarqubePullAndPushView from "../sonarqube/SonarqubePullAndPushView";
import SonarcloudPullAndPushView from "../sonarcloud/SonarcloudPullAndPushView";
import JiraLoginConfigForm from "../jira/JiraLoginConfigForm";
import CommonTicketingForm from "../jira/CommonTicketingForm";
import SlackListing from "../slack/SlackListing";
import HackerOnePullAndPushView from "../hackerone/HackerOnePullAndPushView";
import HackerOneMappingForm from "../hackerone/HackerOneMappingForm";
import TwistLockPullAndPushView from "../twistlock/TwistLockPullAndPushView";
import NowSecurePullAndPushView from "../nowsecure/NowSecurePullAndPushView";
import FortifyPullAndPushView from "../fortify/FortifyPullAndPushView";
import QwietAIPullAndPushView from "../qwietAI/QwietAIPullAndPushView";
import SnykPullAndPushView from "../snyk/SnykPullAndPushView";
import CheckmarxPullAndPushView from "../checkmarx/CheckmarxPullAndPushView";
import CheckmarxMappingForm from "../checkmarx/CheckmarxMappingForm";
import BlackDuckPullAndPushView from "../blackDuck/BlackDuckPullAndPushView";
import CoverityPullAndPushView from "../coverity/CoverityPullAndPushView";
import NexposePullAndPushView from "../nexpose/NexposePullAndPushView";
import DependabotPullAndPushView from "../dependabot/DependabotPullAndPushView";
import MSTeamsListing from "../msTeams/MSTeamsListing";
import MSTeamsOAuthPopup from "../msTeams/MSTeamsOAuthPopup";
import Route53Dashboard from "../route-53/Route53Dashboard";
import GithubCodeScanPullAndPushView from "../githubCodeScan/GithubCodeScanPullAndPushView";
import RedlockPullAndPushView from "../redlock/RedlockPullAndPushView";
import LaceworkPullAndPushView from "../lacework/LaceworkPullAndPushView";
import ImpervaAPI from "restAPI/ImpervaAPI";
import ImpervaConfigListing from "../imperva/ImpervaConfigListing";
import ImpervaConfigFormPopup from "../imperva/ImpervaConfigFormPopup";
import GoogleCloudRegistryPullAndPushView from "../googleCloudRegistry/GoogleCloudRegistryPullAndPushView";
import QualysWebappPullAndPushView from "../qualysWebapp/QualysWebappPullAndPushView";
import TenableWebappPullAndPushView from "../tenableWebapp/TenableWebappPullAndPushView";
import TenableInfraPullAndPushView from "../tenableInfra/TenableInfraPullAndPushView";
import TenableInfraMappingForm from "../tenableInfra/TenableInfraMappingForm";
import ThreatModelerPullAndPushView from "../threatmodeler/ThreatModelerPullAndPushView";
import ThreatModelerCredentialsForm from "../threatmodeler/ThreatModelerCredentialsForm";
import SonatypeLifecyclePullAndPushView from "../sonatypeLifecycle/SonatypeLifecyclePullAndPushView";
import Rapid7InsightPullAndPushView from "../rapid7Insight/Rapid7InsightPullAndPushView";
import QualysInfraPullAndPushView from "../QualysInfra/QualysInfraPullAndPushView";
import MendPullAndPushView from "../mend/MendPullAndPushView";
import MendMappingForm from "../mend/MendMappingForm";
import GoogleSecurityCommandCenterPullAndPushView from "../googleSecurityCommandCenter/GoogleSecurityCommandCenterPullAndPushView";
import VeracodePullAndPushView from '../veracode/VeracodePullAndPushView'
import NetSparkerPullAndPushView from "../netSparker/NetSparkerPullAndPushView";
import NetSparkerMappingForm from "../netSparker/NetSparkerMappingForm";
import GitRepoConfigForm from "../GitRepoConfigForm";
import RepoListingTable from "../RepoListingTable";
import SlackOAuthPopup from "../slack/SlackOAuthPopup";
import _ from "lodash";
import ContrastSecurityPullAndPushView from "../contrastSecurity/ContrastSecurityPullAndPushView";
import AcunetixPullAndPushView from "../acunetix/AcunetixPullAndPushView";
import AcunetixMappingForm from "../acunetix/AcunetixMappingForm";
import EnvironmentName from "views/GlobalSettings/EnvironmentName";
import BridgecrewPullAndPushView from "../bridgecrew/BridgecrewPullAndPushView";
import SecurityScorecardPullAndPushView from "../securityScorecard/SecurityScorecardPullAndPushView";
import SecurityScorecardMappingForm from "../securityScorecard/SecurityScorecardMappingForm";
import BurpsuiteEnterprisePullAndPushView from '../burpsuiteEnterprise/BurpsuiteEnterprisePullAndPushView';
import OrcaSecurityPullAndPushView from '../orcaSecurity/OrcaSecurityPullAndPushView';
import GuardDutyWebhookSuccessPopup from "../aws/GuardDutyWebhookSuccessPopup";
import SecurityHubWebhookSuccessPopup from "../aws/SecurityHubWebhookSuccessPopup";
import EdgescanPullAndPushView from '../edgescan/EdgescanPullAndPushView';
import EdgescanMappingForm from '../edgescan/EdgescanMappingForm';
import NodeZeroPullAndPushView from  '../nodeZero/NodeZeroPullAndPushView';
import WhiteHatSentinelPullAndPushView from '../whiteHatSentinel/WhiteHatSentinelPullAndPushView';
import WhiteHatSentinelMappingForm from "../whiteHatSentinel/WhiteHatSentinelMappingForm";
import AmazonInspectorWebhookSuccessPopup from "../aws/AmazonInspectorWebhookSuccessPopup";
import WallarmPullAndPushView from "../wallarm/WallarmPullAndPushView";
import WallarmCredentialForm from "../wallarm/WallarmCredentialForm";
import GitGuardianPullAndPushView from "../gitGuardian/GitGuardianPullAndPushView";
import GitGuardianCredentialsForm from "../gitGuardian/GitGuardianCredentialsForm";
import AppknoxPullAndPushView from  '../appknox/AppknoxPullAndPushView';
import Rapid7InsightVMPullAndPushView from  '../rapid7InsightVM/Rapid7InsightVMPullAndPushView';
import VMSecureStatePullAndPushView from "../vmsecurestate/VMSecureStatePullAndPushView";
import TaniumPullAndPushView from "../tanium/TaniumPullAndPushView";
import CobaltPullAndPushView from "../cobalt/CobaltPullAndPushView";
import CobaltCredentialForm from "../cobalt/CobaltCredentialForm";
import TraceablePullAndPushView from "../traceable/TraceablePullAndPushView";
import TraceableCredentialForm from "../traceable/TraceableCredentialForm";
import AutomoxConfigForm from "../automax/AutomoxConfigForm";
import AutomoxListingTable from '../automax/AutomoxListingTable'
import CheckmarxSCAPullandPushView from "../checkmarxSca/CheckmarxSCAPullandPushView";
import CheckmarxSCACredentialForm from "../checkmarxSca/CheckmarxSCACredentialForm";
import JfrogXrayPullAndPushView from "../jfrogXray/JfrogXrayPullAndPushView";
import JfrogXrayCredentialForm from "../jfrogXray/JfrogXrayCredentialForm";
import SonraiPullAndPushView from "../sonrai/SonraiPullAndPushView";
import SonraiCredentialForm from "../sonrai/SonraiCredentialsForm";
import DataTheoremPullAndPushView from "../dataTheorem/DataTheoremPullAndPushView";
import DataTheoremCredentialForm from "../dataTheorem/DataTheoremCredentialForm";
import CloudOptixPullAndPushView from "../cloudOptix/CloudOptixPullAndPushView";
import CloudOptixCredentialForm from "../cloudOptix/CloudOptixCredentialForm";
import CrowdStrikeSpotlightPullAndPushView from "../crowdStrikeSpotlight/CrowdStrikeSpotlightPullAndPushView";
import CrowdStrikeSpotlightCredentialsForm from "../crowdStrikeSpotlight/CrowdStrikeSpotlightCredentialsForm";
import SysDigPullAndPushView from "../sysdig/SysDigPullAndPushView";
import GithubSecretScanPullAndPushView from '../githubSecretScan/GithubSecretScanPullAndPushView'
import GithubSecretScanCredentialsForm from "../githubSecretScan/GithubSecretScanCredentialsForm";
import StackhawkPullAndPushView from "../stackhawk/StackhawkPullAndPushView";
import CheckmarxOnePullAndPushView from "../checkmarxOne/CheckmarxOnePullAndPushView";
import CheckmarxOneCredentialForm from "../checkmarxOne/CheckmarxOneCredentialForm";
import GrammatechCodeSentryPullAndPushView from "../grammatechCodeSentry/GrammatechCodeSentryPullAndPushView";
import GrammatechCodeSonarPullAndPushView from "../grammatechCodeSonar/GrammatechCodeSonarPullAndPushView";
import WizPullAndPushView from "../wiz/WizPullAndPushView";
import WizCredentialsForm from "../wiz/WizCredentialsForm";
import VdooPullAndPushView from "../vdoo/VdooPullAndPushView";
import VdooCredentialsForm from "../vdoo/VdooCredentialsForm";
import ProbelyPullAndPushView from "../probely/ProbelyPullAndPushView";
import ProbelyCredentialsForm from "../probely/ProbelyCredentialsForm";
import HashiCorpVaultRadarPullAndPushView from "../hashicorpVaultRadar/HashiCorpVaultRadarPullAndPushView";
import HashiCorpVaultRadarCredentialsForm from "../hashicorpVaultRadar/HashiCorpVaultRadarCredentialsForm";
import SemgrepPullAndPushView from "../semgrep/SemgrepPullAndPushView";
import SemgrepCredentialsForm from "../semgrep/SemgrepCredentialsForm";
import SemgrepMappingForm from "../semgrep/SemgrepMappingForm";
import BugCrowdPullAndPushView from "../bugCrowd/BugCrowdPullAndPushView";
import RunZeroPullAndPushView from "../runZero/RunZeroPullAndPushView";
import RunZeroCredentialsForm from "../runZero/RunZeroCredentialsForm";
import MergeBasePullAndPushView from "../mergebase/MergeBasePullAndPushView";
import MergeBaseCredentialsForm from "../mergebase/MergeBaseCredentialsForm";
import FiniteStatePullAndPushView from "../finitestate/FiniteStatePullAndPushView";
import SpectralPullAndPushView from "../spectral/SpectralPullAndPushView";
import SpectralCredentialsForm from "../spectral/SpectralCredentialsForm";
import SeekerPullAndPushView from "../seeker/SeekerPullAndPushView";
import SeekerCredentialsForm from "../seeker/SeekerCredentialsForm";
import ClaytonPullAndPushView from "../clayton/ClaytonPullAndPushView";
import ClaytonCredentialsForm from "../clayton/ClaytonCredentialsForm";
import ApiiroPullAndPushView from "../apiiro/ApiiroPullAndPushView";
import ApiiroCredentialForm from "../apiiro/ApiiroCredentialForm";
import TenableScPullAndPushView from "../tenablesc/TenableScPullAndPushView";
import AmazonInspectorPullAndPushView from "../aws/AmazonInspectorPullAndPushView";
import LaceWorkWebhookSuccessPopup from "../aws/LaceWorkWebhookSuccessPopup";
import PolarisPullAndPushView from "../polaris/PolarisPullAndPushView";
import PolarisCredentialsForm from "../polaris/PolarisCredentialsForm";
import CortexCredentialsForm from "../cortex/CortexCredentialsForm";
import CortexPullAndPushView from "../cortex/CortexPullAndPushView";
import CortexMappingForm from "../cortex/CortexMappingForm";
import AlertConnectListing from "../alertConnect/AlertConnectListing";
import AlertConfigFormPopup from "../alertConnect/AlertConfigFormPopup";
import IriusRiskPullAndPushView from "../iriusRisk/IriusRiskPullAndPushView";
import IriusRiskCredentialsForm from "../iriusRisk/IriusRiskCredentialsForm";
import VersionOneConfigForm from "../VersionOne/VersionOneConfigForm";
import SDElementsPullAndPushView from "../sdElements/SDElementsPullAndPushView";
import SDElementsMappingForm from "../sdElements/SDElementsMappingForm";
import SDElementsCredentialsForm from "../sdElements/SDElementsCredentialsForm";
import { TICKET_SYSTEM_TYPE_DISPLAY_TEXT } from 'constants/TicketContants';
import MeterianPullAndPushView from "../meterian/MeterianPullAndPushView";
import MeterianCredentialsForm from "../meterian/MeterianCredentialsForm";
import TenableCloudSecurityPullAndPushView from "../tenableCloudSecurity/TenableCloudSecurityPullAndPushView";
import TenableCloudSecurityCredentialsForm from "../tenableCloudSecurity/TenableCloudSecurityCredentialsForm";
import RedhatACSPullAndPushView from "../redhatACS/RedhatACSPullAndPushView";
import RedhatACSCredentialsForm from "../redhatACS/RedhatACSCredentialsForm";
import HaloSecurityCredentialsForm from "../haloSecurity/HaloSecurityCredentialsForm";
import HaloSecurityPullAndPushView from "../haloSecurity/HaloSecurityPullAndPushView";
import CycodeCredentialsForm from "../cycode/CycodeCredentialsForm";
import CycodePullAndPushView from "../cycode/CycodePullAndPushView";
import DeepfencePullAndPushView from "../deepfence/DeepfencePullAndPushView";
import DeepfenceCredentialsForm from "../deepfence/DeepfenceCredentialsForm";
import ThreatConnectConfigForm from "../ThreatConnect/ThreatConnectConfigForm";
import ThreatConnectListing from "../ThreatConnect/ThreatConnectListing";
import GitlabSecurityPullAndPushView from "../gitlabSecurity/GitlabSecurityPullAndPushView";
import GitlabSecurityCredentialsForm from "../gitlabSecurity/GitlabSecurityCredentialsForm";
import DependabotSyncPRsConfig from "../dependabot/DependabotSyncPRsConfig";
import Device42Listing from "../device42/Device42Listing";
import Device42ModalForm from "../device42/Device42ModalForm";
import FlashPointConfigForm from "../FlashPoint/FlashPointConfigForm";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import RallyLoginConfigForm from "../Rally/RallyLoginConfigForm";
import MendIOPullAndPushView from "../mend.io/MendIOPullAndPushView";
import MendIOCredentialsForm from "../mend.io/MendIOCredentialsForm";
import ArmorCodeAgents from "../armorcodeAgent/ArmorCodeAgents";
import TenableVulnerabilityManagementPullAndPushView from "../tenableVulnerabilityManagement/TenableVulnerabilityManagementPullAndPushView";
import MicrosoftDefenderPullAndPushView from "../microsoftDefender/MicrosoftDefenderPullAndPushView";
import MicrosoftDefenderCredentialsForm from "../microsoftDefender/MicrosoftDefenderCredentialsForm";
import UpGuardPullAndPushView from "../upguard/UpGuardPullAndPushView";
import UpGuardCredentialsForm from "../upguard/UpGuardCredentialsForm";
import TenableVulnerabilityManagementCredentialsForm from "../tenableVulnerabilityManagement/TenableVulnerabilityManagementCredentialsForm";
import UpGuardMappingForm from "../upguard/UpGuardMappingForm";
import BitSightPullAndPushView from "../bitSight/BitSightPullAndPushView";
import BitSightCredentialsForm from "../bitSight/BitSightCredentialsForm";
import LeanIXConfigForm from "../LeanIX/LeanIXConfigForm";
import LeanIXListing from "../LeanIX/LeanIXListing";
import SnykCredentialsForm from "../snyk/SnykCredentialsForm";
import Crunch42PullAndPushView from "../crunch42/Crunch42PullAndPushView";
import Crunch42CredentialsForm from "../crunch42/Crunch42CredentialsForm";
import MicrosoftDefenderForEndPointPullAndPushView from "../miscrosoftDefenderForEndpoint/MicrosoftDefenderForEndpointPullAndPushView";
import MicrosoftDefenderForEndpointCredentialsForm from "../miscrosoftDefenderForEndpoint/MicrosoftDefenderForEndpointCredentialsForm";
import SentinelOnePullAndPushView from "../sentinelOne/SentinelOnePullAndPushView";
import SentinelOneCredentialsForm from "../sentinelOne/SentinelOneCredentialsForm";
import NonamePullAndPushView from "../noname/NonamePullAndPushView";
import NonameCredentialsForm from "../noname/NonameCredentialsForm";
import { getFeatureFlags_UNSAFE } from "contexts/FeatureFlagContext";
import SnykMappingForm from "../snyk/SnykMappingFormV2";
import SnykMappingFormNew from "../snyk/SnykMappingFormNew";
import AppcheckPullAndPushView from "../appcheck/AppcheckPullAndPushView";
import AppcheckCredentialsForm from "../appcheck/AppcheckCredentialsForm";
import EndorLabsPullAndPushView from "../endorLabs/EndorLabsPullAndPushView";
import EndorLabsCredentialsForm from "../endorLabs/EndorLabsCredentialsForm";
import SecureCodeWarriorForm from "../secureCodeWarrior/SecureCodeWarriorForm";
import CheckmarxCodebashingForm from "../checkmarxCodebashing/CheckmarxCodebashingForm";
import RiskReconPullAndPushView from "../riskrecon/RiskReconPullAndPushView";
import RiskReconCredentialsForm from "../riskrecon/RiskReconCredentialsForm";
import PrivadoPullAndPushView from "../privado/PrivadoPullAndPushView";
import PrivadoCredentialsForm from "../privado/PrivadoCredentialsForm";
import AWSSecurityHUbPullAndPushView from "../aws/AWSSecurityHubPullAndPushView";
import ServiceNowLoginConfigForm from "../serviceNow/ServiceNowLoginConfigForm";
import BitBucketConfigForm from "../bitbucket/BitBucketConfigForm";
import DependencyTrackPullAndPushView from "../dependencyTrack/DependencyTrackPullAndPushView";
import DependencyTrackCredentialsForm from "../dependencyTrack/DependencyTrackCredentialsForm";
import MandiantAdvantageConfigLoginForm from "../MandiantAdvantage/MandiantAdvantageConfigLoginForm";
import OligoPullAndPushView from "../oligo/OligoPullAndPushView";
import OligoCredentialsForm from "../oligo/OligoCredentialsForm";
import BackstageConfigForm from "../backstage/BackstageConfigForm";
import BackstageListing from "../backstage/BackstageListing";
import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import OrcaSecurityShiftLeftPullAndPushView from "../orcaSecurityShiftLeft/OrcaSecurityShiftLeftPullAndPushView";
import OrcaSecurityShiftLeftCredentialsForm from "../orcaSecurityShiftLeft/OrcaSecurityShiftLeftCredentialsForm";
import AppSentinelsPullAndPushView from "../appSentinels/AppSentinelsPullAndPushView";
import AppSentinelsCredentialForm from "../appSentinels/AppSentinelsCredentialForm";
import AzureBoardMappingForm from "../azureBoard/AzureBoardMappingForm";
import ATSConfigLoginForm from "../ArmorCodeTicketingSystem(ATS)/ATSConfigLoginForm";
import SynopsysPolarisPullAndPushView from "../synopsysPolaris/SynopsysPolarisPullAndPushView";
import SynopsysPolarisCredentialsForm from "../synopsysPolaris/SynopsysPolarisCredentialsForm";
import ZendDesklConfigLoginForm from "../Zendesk/ZendDesklConfigLoginForm";
import GenericSyncPRsConfig from "../GenericSyncPRsConfig";
import AzureBoardConfigLoginForm from "../azureBoard/AzureBoardConfigLoginForm";
import AsanaConfigLoginForm from "../Asana/AsanaConfigLoginForm";
import AsanaConfigMappingForm from "../Asana/AsanaConfigMappingForm";
import JiraPullView from "../JiraSecurityTool/JiraSecurityToolPullView";
import SocketDevPullAndPushView from "../socket.dev/SocketDevPullAndPushView";
import SocketDevCredentialsForm from "../socket.dev/SocketDevCredentialsForm";
import Rapid7InsightCloudPullAndPushView from "../rapid7InsightCloudSecurity/Rapid7InsightCloudPullAndPushView";
import Rapid7InsightCloudCredentialsForm from "../rapid7InsightCloudSecurity/Rapid7InsightCloudCredentialsForm";
import AcunetixPremiumCredentialsForm from "../acunetixPremium/AcunetixPremiumCredentialsForm";
import AcunetixPremiumPullAndPushView from "../acunetixPremium/AcunetixPremiumPullAndPushView";
import CybeatsPullAndPushView from "../cybeats/CybeatsPullAndPushView";
import CybeatsCredentialsForm from "../cybeats/CybeatsCredentialsForm";
import PenTestToolPullAndPushView from "../penTestTool/PenTestToolPullAndPushView";
import PenTestToolCredentialsForm from "../penTestTool/PenTestToolCredentialsForm";
import ServiceNowIntegrationListing from "../serviceNow/ServiceNowIntegrationListing";
import GithubCodeScanCredentialsForm from "../githubCodeScan/GithubCodeScanCredentialsForm";
import PrismaCloudComputePullAndPushView from "../prismaCloudCompute/PrismaCloudComputePullAndPushView";
import PrismaCloudComputeCredentialsForm from "../prismaCloudCompute/PrismaCloudComputeCredentialsForm";
import DataDogConfigLoginForm from "../DataDog/DataDogConfigLoginForm";
import DataDogConfigListing from "../DataDog/DataDogConfigListing";
import QualysContainerSecurityPullAndPushView from "../qualysContainerSecurity/QualysContainerSecurityPullAndPushView";
import QualysContainerSecurityCredentialsForm from "../qualysContainerSecurity/QualysContainerSecurityCredentialsForm";
import UpwindPullAndPushView from "../upwind/UpwindPullAndPushView";
import UpwindCredentialsForm from "../upwind/UpwindCredentialsForm";
import QualysPolicyCompliancePullAndPushView from "../QualysPolicyCompliance/QualysPolicyCompliancePullAndPushView";
import QualysPolicyComplianceCredentialsForm from "../QualysPolicyCompliance/QualysPolicyComplianceCredentialsForm";
import ArnicaPullAndPushView from "../arnica/ArnicaPullAndPushView";
import ArnicaCredentialsForm from "../arnica/ArnicaCredentialsForm";
import ReversingLabSpectraPullAndPushView from "../reversingLab/ReversingLabSpectraPullAndPushView";
import ReversingLabSpectraCredentialsForm from "../reversingLab/ReversingLabSpectraCredentialsForm";
import MobbSecurityListing from "../mobbSecurity/MobbSecurityListing";
import MobbSecurityConfigForm from "../mobbSecurity/MobbSecurityConfigForm";
import SonarqubeMappingForm from "../sonarqube/SonarqubeMappingForm";
import ArcherIntegrationMappingForm from "../Archer/ArcherIntegrationMappingForm";
import ArcherIntegrationLoginform from "../Archer/ArcherIntegrationLoginform";
import GithubActionsDashboard from "../githubActions/GithubActionsDashboard";
import GithubActionsFormPopup from "../githubActions/GithubActionsFormPopup";
import AxoniusPullAndPushView from "../axonius/AxoniusPullAndPushView";
import AxoniusCredentialsForm from "../axonius/AxoniusCredentialsForm";
import BlackduckBinaryAnalysisPullAndPushView from "../blackduckBinaryAnalysis/BlackduckBinaryAnalysisPullAndPushView";
import BlackduckBinaryAnalysisCredentialsForm from "../blackduckBinaryAnalysis/BlackduckBinaryAnalysisCredentialsForm";
import FreshServiceIntegrationListing from "../FreshService/FreshServiceIntegrationListing";
import FreshServiceMappingForm from "../FreshService/FreshServiceMappingForm";
import JiraMappingForm from "../jira/JiraMappingForm";
import GitLabIssuesIntegrationListing from "../GitLabIssues/GitLabIssuesIntegrationListing";
import ZendeskIntegrationListing from "../Zendesk/ZendeskIntegrationListing";
import ZenDeskConfigMappingForm from "../Zendesk/ZenDeskConfigMappingForm";
import AsanaIntegrationListing from "../Asana/AsanaIntegrationListing";
import RallyIntegrationListing from "../Rally/RallyIntegrationListing";
import VersionOneIntegrationListing from "../VersionOne/VersionOneIntegrationListing";
import VersionOneMappingForm from "../VersionOne/VersionOneMappingForm";
import OstorlabPullAndPushView from "../ostorlab/OstorlabPullAndPushView";
import OstorlabCredentialsForm from "../ostorlab/OstorlabCredentialsForm";
import HCLAppscanPullAndPushView from "../hclappscan/HCLAppscanPullAndPushView";
import HCLAppscanCredentialsForm from "../hclappscan/HCLAppscanCredentialsForm";
import HCLAppscanCloudPullAndPushView from "../hclappscancloud/HCLAppscanCloudPullAndPushView";
import HCLAppscanCloudCredentialsForm from "../hclappscancloud/HCLAppscanCloudCredentialsForm";
import PagerDutyIntegrationListing from "../PagerDuty/PagerDutyIntegrationListing";
import JiraIntegrationLoginConfigForm from "../jira/JiraIntegrationLoginConfigForm";
import ApiSecPullAndPushView from "../apisec/ApiSecPullAndPushView";
import ApiSecCredentialsForm from "../apisec/ApiSecCredentialsForm";
import { ZscalerLogsView, ZscalerS3API } from "../zscaler";
import { CrowdStrikeEdrView, CrowdStrikeEdrAPI } from "../crowdstrikeEdr";
import SentinelOneLogsView from "../sentinelOneLogs/SentinelOneLogsView";
import GoogleWorkspaceView from "../googleWorkspace/GoogleWorkspaceView";
import { GoogleWorkspaceAPI } from "../googleWorkspace/googleWorkspaceConstants";
import { SentinelOneS3API } from "../sentinelOneLogs/sentinelOneLogsConstants";
import UltraVioletPullAndPushView from "../ultraviolet/UltraVioLetPullAndPushView";
import UltraVioletCredentialsForm from "../ultraviolet/UltraVioletCredentialsForm";
// import ServiceNowLoginConfigForm from "../serviceNow/ServiceNowLoginConfigForm";

export const SNYK_CATEGORY = [
    "SCA",
    "SAST",
    "IaC",
    "Container Security",
    "SBOM"
];

export const SEMGREP_CATEGORY = [
    "SCA",
    "SAST"
];

export const SEMGREP_CATEGORY_SECRETS = [
    "SCA",
    "SAST",
    "Secrets"
];

const IntegrationToolsData = Object.freeze([
    {
        "id": "AWS",
        "name": "AWS Infrastructure",
        "type": "",
        "isActive": true,
        "category": ["Asset Management"],
        "toolType":"",
        "description": "",
        "icon": "/images/aws.svg",
        listingAPI: ToolsIntegrationsAPI.getGenericLoginDetail,
        listingAPIFlagKey: "RBVM_ASSETS",
        ConfigComponent: (props) => <Route53Dashboard isAWSInfra {...props} />,
        plusButtonTextFlagKey: "RBVM_ASSETS",
    },
    {
        "id": "zscaler_logs",
        "name": "Zscaler Logs",
        "isActive": true,
        "category": "AI Exposure",
        "toolType": "paid",
        "featureKey": "AI_RISK_MANAGEMENT",
        "description": "Ingest Zscaler NSS logs from S3 for AI Exposure Management",
        "icon": "/images/zscaler-logs.png",
        deleteAPI: ZscalerS3API.deleteConfiguration,
        ConfigComponent: ZscalerLogsView,
        hidePullView: true,
        hidePushView: true,
    },
    {
        "id": "crowdstrike_edr_web",
        "name": "CrowdStrike EDR",
        "isActive": true,
        "category": "AI Exposure",
        "toolType": "paid",
        "featureKey": "AI_RISK_MANAGEMENT",
        "description": "Upload CrowdStrike EDR logs for AI Exposure Management",
        "icon": "/images/crowdstrike falcon.svg",
        deleteAPI: CrowdStrikeEdrAPI.deleteConfiguration,
        ConfigComponent: CrowdStrikeEdrView,
        hidePullView: true,
        hidePushView: true,
    },
    {
        "id": "sentinelone_s3",
        "name": "SentinelOne EDR",
        "isActive": true,
        "category": "AI Exposure",
        "toolType": "paid",
        "featureKey": "AI_RISK_MANAGEMENT",
        "description": "Ingest SentinelOne EDR logs from S3 for AI Exposure Management",
        "icon": "/images/sentinelone.svg",
        deleteAPI: SentinelOneS3API.deleteConfiguration,
        ConfigComponent: SentinelOneLogsView,
        hidePullView: true,
        hidePushView: true,
    },
    {
        "id": "google_workspace",
        "name": "Google Workspace",
        "isActive": true,
        "category": "AI Exposure",
        "toolType": "paid",
        "featureKey": "AI_RISK_MANAGEMENT",
        "description": "Ingest Google Workspace activity logs for AI Exposure Management",
        "icon": "/images/google.svg",
        deleteAPI: GoogleWorkspaceAPI.deleteConfiguration,
        ConfigComponent: GoogleWorkspaceView,
        hidePullView: true,
        hidePushView: true,
    },
    {
        "id": "GitHub",
        "name": "GitHub",
        "type": "Build",
        "isActive": true,
        "category": ["Repository", "Ticketing", "SBOM"],
        "toolType":"buildTools",
        "description": "Git Repository hosting service. It also provides access control and several collaboration tools.",
        "icon": "/images/github.svg",
        listingAPI: ToolsIntegrationsAPI.getInstallationsByRepoType,
        ConfigComponent: GithubDashboardNew,
        ModalFormComponent: GithubEnterpriseForm,
        plusButtonText: null,
        showAdditionalSettingsButton: true,
        // in a rare case GitHub integration is not behind any feature flag, just to show manage template button requires a specific feature flag check
        // in this case we can use the templateButtonFeatureFlag to check if the button should be shown
        templateButtonFeatureFlag: "GITHUB_ISSUES_CONFIG"
    },
    /*{
    
        "id": "route-53",
        "name": "Route 53",
        "type": "Build",
        "isActive": true,
        "category": "DNS",
        "icon": "/images/route53.svg",
        keyNameForAPI: "ROUTE53",
        ConfigComponent: Route53Dashboard,
        plusButtonText: null,
    },*/
    {
    
        "id": "Jenkins",
        "name": "Jenkins",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "Jenkins helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/jenkins.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup
    },
    {
    
        "id": "Bamboo",
        "name": "Bamboo",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "Bamboo helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/bamboo.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup
    },
    {
    
        "id": "Circle_CI",
        "name": "Circle CI",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "CircleCI helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/circleci.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup,
    },
    {
    
        "id": "BuildKite",
        "name": "BuildKite",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "BuildKite helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/buildkite.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup,
        keyNameForAPI: "BUILD KITE"
    },
    {
    
        "id": "Team_City",
        "name": "Team City",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "Team City helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/teamcity.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup,
    },
    {
    
        "id": "Drone",
        "name": "Drone",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "Drone helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/drone.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup
    },
    {
    
        "id": "ReleaseIQ",
        "name": "Release IQ",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "ReleaseIQ helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/ReleaseIQ.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup,
        keyNameForAPI: "RELEASE_IQ"
    },
    {
    
        "id": "Azure_Pipeline",
        "name": "Azure Pipeline",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "Azure Pipeline helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/azure-pipeline.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup
    },
    {
    
        "id": "GitHub_Actions",
        "name": "GitHub Actions",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "GitHub Actions helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/gitactions.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: GithubActionsDashboard,
        ModalFormComponent: GithubActionsFormPopup
    },
    {
        "id": "GitLab_CI",
        "name": "GitLab CI",
        "type": "Build",
        "isActive": true,
        "category": "CI/CD",
        "toolType":"buildTools",
        "description": "GitLab CI helps automate the parts of software development related to building, testing, and deploying, facilitating continuous integration and continuous delivery.",
        "icon": "/images/gitlabcicd.svg",
        "detailsTitle": "Release Management",
        plusButtonText: null,
        ConfigComponent: JenkinsDashboard,
        ModalFormComponent: JenkinsFormPopup,
        keyNameForAPI:"GITLAB_CI"
    },
    {
        "id": "GitLab",
        "name": "GitLab",
        "type": "Build",
        "isActive": true,
        "category": "Repository",
        "toolType":"buildTools",
        "description": "Complete DevOps platform, delivered as a single application.",
        "icon": "/images/gitlab.svg",
        listingAPI: ToolsIntegrationsAPI.getInstallationsByRepoType, 
        ConfigComponent: RepoListingTable,
        ModalFormComponent: GitRepoConfigForm
    },
    {
        "id": "Bitbucket",
        "name": "Bitbucket",
        "type": "Build",
        "isActive": true,
        "category": "Repository",
        "toolType":"buildTools",
        "description": "Git based code hosting and collaboration tool, built for teams.",
        "icon": "/images/bitbucket.svg",
        listingAPI: ToolsIntegrationsAPI.getInstallationsByRepoType, 
        ConfigComponent: RepoListingTable,
        ModalFormComponent: BitBucketConfigForm
    },
    {
        "id": "Azure_Repos",
        "name": "Azure Repos",
        "type": "Build",
        "isActive": true,
        "category": "Repository",
        "toolType":"buildTools",
        "description": "Azure Repos based code hosting and collaboration tool, built for teams.",
        "icon": "/images/azurerepos.svg",
        listingAPI: ToolsIntegrationsAPI.getInstallationsByRepoType, 
        ConfigComponent: RepoListingTable,
        ModalFormComponent: GitRepoConfigForm,
        keyNameForAPI: "AZURE_REPOS",
    },
    {
        "name": "Jira",
        "type": "Ticket",
        "isActive": true,
        "category": ["Ticketing", "Asset Management"],
        categoryFeatureFlag: {
            "RBVM_ASSETS": ["CMDB"],
        },
        "toolType":"ticket",
        "description": "Powerful work management tool for all kinds of use cases.",
        "icon": "/images/jira.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ModalFormComponent: JiraIntegrationLoginConfigForm,
        showManageTicketTemplate: true,
    },
    {
        "name": "Azure Board",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Azure Boards is a service for managing the work for your software projects",
        "icon": "/images/azure-board.png",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ModalFormComponent: AzureBoardConfigLoginForm,
        ConfigMappingForm: AzureBoardMappingForm,
        showManageTicketTemplate: true
    },
    {
        "id": "ServiceNow",
        "name": "Service Now",
        "type": "Ticket",
        "isActive": true,
        "category": ["Ticketing", "CMDB", "Asset Management"],
        "toolType":"ticket",
        "description": "Helps companies manage digital workflows for enterprise operations.",
        "icon": "/images/servicenow.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: ServiceNowIntegrationListing,
        ModalFormComponent: ServiceNowLoginConfigForm,
        // ModalFormComponent: CommonTicketingForm,
        keyNameForAPI: "SERVICE_NOW",
        showManageTicketTemplate: true
    },
    {
        "id": "FreshService",
        "name": "FreshService",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Helps companies manage digital workflows for enterprise operations.",
        "icon": "/images/freshservice.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: FreshServiceIntegrationListing,
        ConfigMappingForm: FreshServiceMappingForm,
        ModalFormComponent: CommonTicketingForm,
        showManageTicketTemplate: true
    },
    {
        "id": "PagerDuty",
        "name": "PagerDuty",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Incident management platform that provides reliable notifications, automatic escalations",
        "icon": "/images/pagerduty.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: PagerDutyIntegrationListing,
        ConfigMappingForm: JiraMappingForm,
        ModalFormComponent: CommonTicketingForm,
    },
    {
        "id": "Slack",
        "name": "Slack",
        "type": "Ticket",
        "isActive": true,
        "category": "Messaging",
        "toolType":"ticket",
        "description": "Includes persistent chat rooms organized by topic, private groups, and direct messaging",
        "icon": "/images/slack.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getSlackWorkSpaceDetails,
        listingAPI: ToolsIntegrationsAPI.getSlackIntegrationDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteSlackConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateSlackIntegrationDetails,
        ConfigComponent: SlackListing,
        ModalFormComponent: SlackOAuthPopup,
    },
    {
        "id": "msteams",
        "name": "MS Teams",
        "isActive": true,
        "category": "Messaging",
        "icon": "/images/msteams.svg",
        keyNameForAPI: "MS_TEAMS",
        "toolType":"ticket",
        loginDetailsAPI: ToolsIntegrationsAPI.getMSTeamsLoginDetails,
        listingAPI: ToolsIntegrationsAPI.getMSTeamsConfiguration, 
        deleteAPI: ToolsIntegrationsAPI.deleteMSTeamsConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateMSTeamsConfiguration,
        ConfigComponent: MSTeamsListing,
        ModalFormComponent: MSTeamsOAuthPopup,
    },
    {
        "id": "imperva",
        "name": "Imperva",
        "type": "Ticket",
        "isActive": true,
        "category": "SIEM",
        "toolType":"ticket",
        "icon": "/images/imperva.svg",
        featureKey: "IMPERVA",
        listingAPI: ImpervaAPI.getConfigs, 
        enabledAPI: ImpervaAPI.createOrUpdateConfig,
        ConfigComponent: ImpervaConfigListing,
        ModalFormComponent: ImpervaConfigFormPopup,
    },
    {
        "id": "Email",
        "name": "Email",
        "type": "Ticket",
        "isActive": true,
        "category": "Email",
        "toolType":"ticket",
        "description": "Email services which helps collaborate with teams and products",
        "icon": "/images/email.svg",
        listingAPI: NotificationAPI.getNotification, 
        ConfigComponent: EmailFormNew
    },
    {
    
        "id": "ArmorCode_API",
        "name": "ArmorCode API",
        "keyNameForAPI": "APIKEY",
        "type": "ArmorCode",
        "isActive": true,
        "category": "API",
        "toolType":"armorcode",
        "description": "ArmorCode API to connect to the platform",
        "icon": "/images/armorcode.svg",
        plusButtonText: "Create New Key",
        // "icon":ApiOutlined,
        listingAPI: IntegrationsAPI.getAllAPIKeys, 
        ConfigComponent: ArmorCodeConfigTable,
        ModalFormComponent: ArmorCodeApiForm
    },
    {
    
        "id": "ArmorCode_Agent",
        "name": "ArmorCode Agent",
        "type": "ArmorCode",
        "isActive": true,
        // "category": "API",
        "toolType":"armorcode",
        // "description": "ArmorCode API to connect to the platform",
        "icon": "/images/armorcode.svg",
        ConfigComponent: ArmorCodeAgents,
    },
    {
        "name": "Shortcut",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Powerful work management tool for all kinds of use cases.",
        "icon": "/images/shortcut.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ConfigMappingForm: JiraMappingForm,
        ModalFormComponent: CommonTicketingForm,
    },
    {
    
        "id": "GitLab Issues",
        "name": "GitLab Issues",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Complete DevOps platform, delivered as a single application.",
        "icon": "/images/gitlab.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GitLabIssuesIntegrationListing,
        ConfigMappingForm: JiraMappingForm,
        ModalFormComponent: CommonTicketingForm,
        keyNameForAPI: "GITLAB_ISSUES",
    },
    {
        "id": "ARMORCODE_TICKETING_SYSTEM",
        "displayName": "ArmorCode Ticketing System", 
        "name": "ARMORCODE_TICKETING_SYSTEM",
        "type": "ArmorCode",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"armorcode",
        "icon": "/images/armorcode.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ModalFormComponent: ATSConfigLoginForm,
        ConfigMappingForm: JiraMappingForm,
        featureKey: "ENABLE_ATS_INTEGRATION"
    },
    {
        "id": "ZENDESK",
        "displayName": "Zendesk", 
        "name": "Zendesk",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "icon": "/images/zendesk.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: ZendeskIntegrationListing,
        ConfigMappingForm: ZenDeskConfigMappingForm,
        ModalFormComponent: ZendDesklConfigLoginForm,
        showManageTicketTemplate: true,
    },
    {
        "id": "ASANA",
        "displayName": "Asana", 
        "name": "Asana",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "icon": "/images/asana.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: AsanaIntegrationListing,
        ModalFormComponent: AsanaConfigLoginForm,
        ConfigMappingForm: AsanaConfigMappingForm,
        showManageTicketTemplate: true,
    },
    {
        "id": "ARCHER",
        "displayName": "Archer", 
        "name": "Archer",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "icon": "/images/archer.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ModalFormComponent: ArcherIntegrationLoginform,
        ConfigMappingForm: ArcherIntegrationMappingForm,
    },
    {
        "id": "DATADOG",
        "displayName": "Datadog Service Management", 
        "name": "DATADOG",
        "type": "CMDB",
        "isActive": true,
        "category": "CMDB",
        "toolType":"cmdb",
        "icon": "/images/datadog.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: DataDogConfigListing,
        ModalFormComponent: DataDogConfigLoginForm,
    },
    {
        "id": "Automox",
        "name": "Automox",
        "type": "Build",
        "isActive": true,
        "category": "Patch Management",
        "toolType":"buildTools",
        "description": "Patch Management Tool",
        // featureKey: "AUTOMOX",
        "icon": "/images/automox.svg",
        listingAPI: ToolsIntegrationsAPI.getAutomoxConfigurations,
        ConfigComponent: AutomoxListingTable,
        ModalFormComponent: AutomoxConfigForm
    },
    {
        "id": "Rally",
        "name": "Rally",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        // "description": "",
        "icon": "/images/rally.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: RallyIntegrationListing,
        ModalFormComponent: RallyLoginConfigForm,
        keyNameForAPI: "RALLY"
    },
    {
        "id": "alertConnect",
        "name": "AlertConnect",
        "type": "Ticket",
        "isActive": true,
        "category": "Messaging",
        "toolType":"armorcode",
        "icon": "/images/armorcode.svg",
        showAddButton: false,
        listingAPI: ToolsIntegrationsAPI.getAllAlertIntegrations, 
        enabledAPI: ToolsIntegrationsAPI.enableDisableAlertIntegration,
        ConfigComponent: AlertConnectListing,
        ModalFormComponent: AlertConfigFormPopup,
    },
    {
        "id": "VERSION_ONE",
        "name": "Version One",
        "displayName": "Digital.ai Agility",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "icon": "/images/versionone.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: VersionOneIntegrationListing,
        ModalFormComponent: VersionOneConfigForm,
        ConfigMappingForm: VersionOneMappingForm,
        keyNameForAPI: "VERSION_ONE",
    },
    {
        id: "THREAT_CONNECT",
        "name": "ThreatConnect",
        "isActive": true,
        "category": "Cyber Threat Intelligence",
        loginDetailsAPI: ToolsIntegrationsAPI.getThreatConnectLoginDetails,
        // listingAPI: ToolsIntegrationsAPI.getTicketSystemToolDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        // enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        "icon": "/images/cti.svg",
        keyNameForAPI: "THREAT_CONNECT",
        ModalFormComponent: ThreatConnectConfigForm,
        ConfigComponent: ThreatConnectListing
    }, {
        "id": "Device42",
        "name": "Device42",
        "type": "Build",
        "isActive": true,
        "category": "Asset Management",
        "toolType":"buildTools",
        "icon": "/images/device42.svg",
        listingAPI: ToolsIntegrationsAPI.getGenericLoginDetail,
        ConfigComponent: Device42Listing,
        ModalFormComponent: Device42ModalForm
    },
    {
        id: "FLASH_POINT",
        "name": "Flashpoint VulnDB",
        "isActive": true,
        "category": "Cyber Threat Intelligence",
        loginDetailsAPI: ToolsIntegrationsAPI.getFlashPointLoginDetails,
        // listingAPI: ToolsIntegrationsAPI.getTicketSystemToolDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        // enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        "icon": "/images/flashpoint.svg",
        keyNameForAPI: "FLASH_POINT",
        ModalFormComponent: FlashPointConfigForm,
        ConfigComponent: ThreatConnectListing,
    },
    {
        id: "MANDIANT_ADVANTAGE",
        "name": "Mandiant Advantage",
        "isActive": true,
        "category": "Cyber Threat Intelligence",
        loginDetailsAPI: ToolsIntegrationsAPI.getMadiantAdvantageLoginDetails,
        // listingAPI: ToolsIntegrationsAPI.getTicketSystemToolDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        // enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        "icon": "/images/MandiantAdvantage.svg",
        keyNameForAPI: "MANDIANT_ADVANTAGE",
        ModalFormComponent: MandiantAdvantageConfigLoginForm,
        ConfigComponent: ThreatConnectListing,
    },
    {
        "id": "LEAN_IX",
        "name": "LEAN_IX",
        "displayName": "LeanIX",
        "type": "Ticket",
        "isActive": true,
        "category": "CMDB",
        "toolType":"ticket",
        "icon": "/images/LeanIX.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails, 
        deleteAPI: ToolsIntegrationsAPI.deleteAsset,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: LeanIXListing,
        ModalFormComponent: LeanIXConfigForm,
        keyNameForAPI: "LEAN_IX"
    },
    {
        "id": "Connect All",
        "name": "Connect All",
        "type": "Ticket",
        "isActive": true,
        "category": "Ticketing",
        "toolType":"ticket",
        "description": "Helps companies manage digital workflows for enterprise operations.",
        "icon": "/images/connectall.svg",
        loginDetailsAPI: ToolsIntegrationsAPI.getTicketSystemToolLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration,
        enabledAPI: ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration,
        ConfigComponent: GenericIntegrationTicketSystemListing,
        ModalFormComponent: CommonTicketingForm,
        ConfigMappingForm: JiraMappingForm,
        keyNameForAPI: "CONNECT_ALL",
    },
    {
        "id": "Secure Code Warrior",
        "name": "Secure Code Warrior",
        "isActive": true,
        "category": "Training",
        "toolType":"",
        "icon": "/images/secure-code-warrior.svg",
        ConfigComponent: SecureCodeWarriorForm,
    },
    {
        "id": "Checkmarx Codebashing",
        "name": "Checkmarx Codebashing",
        "isActive": true,
        "category": "Training",
        "toolType":"",
        "icon": "/images/checkmarx-code-bashing.svg",
        ConfigComponent: CheckmarxCodebashingForm,
    },
    {
        "id": "Backstage",
        "name": "Backstage",
        "isActive": true,
        "category": "Developer Portal",
        "icon": "/images/backstage.svg",
        "toolType": "open",
        loginDetailsAPI: ToolsIntegrationsAPI.getBackstageLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteBackstageConfiguration,
        ConfigComponent: BackstageListing,
        ModalFormComponent: BackstageConfigForm,
    },
    {
        "id": "Mobb Security",
        "name": "Mobb Security",
        "isActive": true,
        "category": "Code Remediation",
        "icon": "/images/mobbSecurity.svg",
        "toolType": "open",
        loginDetailsAPI: ToolsIntegrationsAPI.getMobbSecurityLoginDetails,
        deleteAPI: ToolsIntegrationsAPI.deleteMobbSecurityConfiguration,
        ConfigComponent: MobbSecurityListing,
        ModalFormComponent: MobbSecurityConfigForm,
        keyNameForAPI: "MOBB_SECURITY"
    }
])

export const SecurityToolsData = Object.freeze([
    {
        "id": "tool-id-2",
        "name": "Bandit",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SAST",
        "toolType":"open",
        "tags": [
            "Java",
            "C#",
            "VB.net",
            "PHP",
            "JS"
        ],
        "icon": "/images/Bandit.svg", 
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup, 
    },
    {
        "id": "BLACKDUCK_HUB",
        "name": "Blackduck Hub",
        "isActive": true,
        "category": ["SCA", "License","SBOM"],
        "toolType":"paid",
        "icon": "/images/blackduck-hub-appsec.svg",
        ConfigComponent: BlackDuckPullAndPushView,
        showScanButton: false,
        isBidirectionalTool: true,
        toolStatusFeatureKey: 'BI_DIRECTIONAL_STATUS_BLACKDUCK'
    },
    {
        "id": "tool-id-3",
        "name": "Burpsuite",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "tags": [
            "Java",
            "C#",
            "VB.net",
            "PHP",
            "JS"
        ],
        "description": "Burpsuite is a web application security testing tool",
        "icon": "/images/Burpsuite.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup
    },
    {
        "id": "tool-id-8",
        "name": "Checkmarx",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": "SAST",
        "toolType":"paid",
        "description": "Checkmarx provides tools for different application security analysis types.",
        "icon": "/images/checkmarx-appsec.png", 
        showScanButton: false,
        ConfigComponent: CheckmarxPullAndPushView,
        MappingForm: CheckmarxMappingForm,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true
    },
    {
        "id": "tool-id-12",
        "name": "Contrast Security",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["IAST","SCA", "SAST"],
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/contrast.png",
        ConfigComponent: ContrastSecurityPullAndPushView,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true
    },
    {
        "id": "tool-id-13",
        "name": "Coverity",
        integrationType: IntegrationType.PULL,        
        "isActive": true,
        "category": "SAST",
        "toolType":"paid",
        "description": "Coverity is a SAST tool",
        "icon": "/images/coverity-appsec.png",
        showScanButton: false,
        ConfigComponent: CoverityPullAndPushView,
        isBidirectionalTool: true,
        toolStatusFeatureKey: 'BI_DIRECTIONAL_STATUS_COVERITY'
    },
    {
        "id": "tool-id-4",
        "name": "Dependency Check",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SCA",
        "toolType":"open",
        "tags": [
            "Java",
            "C#",
            "VB.net",
            "PHP",
            "JS"
        ],
        "description": "Dependency-Check is a Software Composition Analysis (SCA) tool that attempts to detect publicly disclosed vulnerabilities contained within a project’s dependencies.",
        "icon": "/images/dependency-check-appsec.png",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup
    },
    {
        "id": "tool-id-6",
        "name": "Fortify",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": ["SAST", "DAST", "MAST"],
        "toolType":"paid",
        "description": "Fortify provides static and dynamic application security testing.",
        "icon": "/images/fortify-appsec.png",
        ConfigComponent: FortifyPullAndPushView,
        showScanButton: false,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true
    },
    {
        "id": "tool-id-10",
        "name": "HackerOne",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": "Bug Bounty",
        "toolType":"paid",
        "description": "HackerOne is a Bug Bounty tool",
        "icon": "/images/hackerone-appsec.png",
        showScanButton: false,
        hidePushView: true,
        ConfigComponent: HackerOnePullAndPushView,
        MappingForm: HackerOneMappingForm,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true
    },
    {
        "id": "tool-id-14",
        "name": "JFrog Xray",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SCA","SBOM"],
        "toolType":"paid",
        "tags": [
            "Java",
            "C#",
            "VB.net",
            "PHP",
            "JS"
        ],
        "description": "JFrog Xray is a SCA tool",
        "icon": "/images/jfrog-xray-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: JfrogXrayPullAndPushView,
        ModalFormComponent: JfrogXrayCredentialForm
    },
    {
        "id": "tool-id-102",
        "name": "Nessus",
        "isActive": true,
        showScanButton: false,
        showAddButton: false,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "description": "Nessus is a MAST tool",
        "icon": "/images/nessus.png",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup
    },
    {
        "id": "tool-id-9",
        "name": "NowSecure",
        "scanName": "NowSecure",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": "MAST",
        "toolType":"paid",
        "description": "NowSecure is a MAST tool",
        "icon": "/images/nowsecure-appsec.svg",
        // loginDetailsAPI: ToolsIntegrationsAPI.getGenericLoginDetail,
        // listingAPI: ToolsIntegrationsAPI.getGenericConfigurationsByToolName,
        // deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        // suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        // ModalFormComponent: NowSecureProjectsMapping,
        showScanButton: false,
        ConfigComponent: NowSecurePullAndPushView
    },
    {
        "id": "tool-id-0",
        "name": "SonarQube",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "toolType":"open",
        "category": ["SAST"],
        "description": "SonarQube is a web-based open source platform used to measure and analyse the source code quality.",
        "icon": "/images/sonarqube-appsec.svg",
        showScanButton: false,
        // loginDetailsAPI: ToolsIntegrationsAPI.getGenericLoginDetail,
        // listingAPI: ToolsIntegrationsAPI.getGenericConfigurationsByToolName,
        // deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        // suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: SonarqubePullAndPushView,
        MappingForm: SonarqubeMappingForm,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true
    },
    {
        "id": "PRISMA_CLOUD_REDLOCK",
        "name": "Prisma Cloud Redlock",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "toolType":"paid",
        "category": ["CSPM"],
        "description": "Prisma Cloud RedLock is a cloud workload compliance platform that integrates multiple capabilities to help organizations identify potential risks and misconfiguration that could lead to security and regulatory policy violations.",
        "icon": "/images/redlock.svg",
        showScanButton: false,
        ConfigComponent: RedlockPullAndPushView,
        isBidirectionalTool: true
    },{
        "id": "tool-id-1",
        "name": "ZAP",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"open",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "description": "Zaproxy is an integrated penetration testing tool for finding vulnerabilities in web applications",
        "icon": "/images/zap-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup
    },
    {
        "id": "qualys_webapp",
        "name": "Qualys WebApp",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "description": "Qualys Webapp is a DAST tool",
        "icon": "/images/qualys-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: QualysWebappPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "qualys_infrastructure",
        "name": "Qualys Infrastructure",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category":[ "Infrastructure Tools", "Asset Management"],
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "description": "Qualys Infrastructure is a DAST tool",
        "icon": "/images/qualys-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: QualysInfraPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup
    },
    // new tools
    {
        "id": "acunetix",
        "name": "Acunetix",
        integrationType: IntegrationType.PULL,
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/acunetix-appsec.svg",
        ConfigComponent: AcunetixPullAndPushView,
        MappingForm: AcunetixMappingForm
    },
    {
        "id": "appscan",
        "name": "Appscan",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["DAST", "MAST", "SAST"],
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/appscan-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "metasploit",
        "name": "Metasploit",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Pentesting Framework"],
        "toolType":"paid",
        "icon": "/images/metasploit-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "aqua",
        "name": "Aqua",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": ["CSPM", "Container Security", "SCA", "SAST", "IaC", "Infrastructure Tools", "Secrets"],
        "toolType":"paid",
        "icon": "/images/aqua-appsec.svg",
        showScanButton: false,
        hidePushView: true,
        // loginDetailsAPI: ToolsIntegrationsAPI.getGenericLoginDetail,
        // listingAPI: ToolsIntegrationsAPI.getGenericConfigurationsByToolName,
        // deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        // suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: AquasecPullAndPushView,
        // ModalFormComponent: AquasecCredentialsForm,
    },
    {
        "id": "aws_security_hub",
        "name": "AWS Security Hub",
        showScanButton: false,
        showAddButton: false,
        showWebHookView: true,
        deprecateWebhook: true,
        webHookInfo: "Webhook scan trigger after 1 hour",
        showOnlyToken: true,
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "icon": "/images/aws-security-hub-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: AWSSecurityHUbPullAndPushView,
        WebhookSuccessComponent: SecurityHubWebhookSuccessPopup,
        ModalFormComponent: IngestionScriptFormPopup
    },
    {
        "id": "brakeman",
        "name": "Brakeman",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SAST",
        "toolType":"open",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/brakeman-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
        allowZip: true
    },
    {
        "id": "bugcrowd",
        "name": "Bugcrowd",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Bug Bounty",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/bugcrowd-appsec.svg",
        ConfigComponent: BugCrowdPullAndPushView,
    },
    {
        "id": "cobalt",
        "name": "Cobalt",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Pentesting Framework",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/cobalt.png",
        ConfigComponent: CobaltPullAndPushView,
        ModalFormComponent: CobaltCredentialForm
    },
    {
        "id": "microfocus_webinspect",
        "name":  "Web Inspect",
        "scanName": "Web Inspect",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/microfocus-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "gitleaks",
        "name": "Gitleaks",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SAST", "Secrets"],
        "toolType":"open",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/gitleaks-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "mozilla_observatory",
        "name": "Mozilla Observatory",
        showScanButton: false,
        showAddButton: false,
        isActive: true,
        "category": "DAST",
        "toolType":"open",
        "description":"Mozilla Observatory is a DAST tool",
        "icon": "/images/mozilla-observatory-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "netsparker",
        "name": "Netsparker",
        displayName: "Netsparker (Invicti)",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/netsparker-appsec.svg",
        ConfigComponent: NetSparkerPullAndPushView,
        MappingForm: NetSparkerMappingForm,
        ModalFormComponent: IngestionScriptFormPopup,
        feature: "NETSPARKER",
        isBidirectionalTool: true
    },
    {
        "id": "nikto",
        "name": "Nikto",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"open",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/nikto-appsec.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "snyk",
        "name": "Snyk",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": SNYK_CATEGORY,
        "toolType":"paid",
        "icon": "/images/snyk-icon.png",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: SnykPullAndPushView,
        ModalFormComponent: SnykCredentialsForm,
        isBidirectionalTool: true,
        MappingForm: getFeatureFlags_UNSAFE().SNYK_PROJECTS_BY_TARGET ?  SnykMappingFormNew: SnykMappingForm
    },
    {
        "id": "PRISMA_CLOUD_TWISTLOCK",
        "name": "Prisma Cloud Twistlock",
        displayName: "Prisma Cloud Twistlock (Deprecated)",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": ["Container Security","SAST","SCA", "IaC", "Infrastructure Tools", "Secrets"],
        "toolType":"paid",
        "icon": "/images/twistlock-appsec.svg",
        showScanButton: false,
        ConfigComponent: TwistLockPullAndPushView,
        ToolSettingsComponent: GenericSyncPRsConfig,
        allowZip: true,
        featureKey: "ENABLE_DEPRECATED_PRISMA_CLOUD_TWISTLOCK",
    },
    {
        "id": "mend",
        "name": "Mend",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        categoryFeatureFlag: {
            "MEND_FETCH_LICENSE_FINDINGS": ["License"],
        },
        "category": ["SCA","SBOM"],
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/mend.svg",
        ConfigComponent: MendPullAndPushView,
        MappingForm: MendMappingForm,
        isBidirectionalTool: true
    },
    {
        "id": "veracode",
        "name": "Veracode",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["DAST","SAST","SCA"],
        "toolType":"paid",
        "tags": [
            "Java",
            "JS",
            "Ruby"
        ],
        "icon": "/images/veracode-icon.png",
        ConfigComponent: VeracodePullAndPushView,
        isBidirectionalTool: true
    },
    {
        "id": "DETECT_SECRETS",
        "name": "Detect Secrets",
        "isActive": true,
        "category": ["SAST", "Secrets"],
        "toolType":"open",
        showScanButton: false,
        showAddButton: false,
        "icon": "/images/detect-secret.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "QWIET_AI",
        "name": "Qwiet AI",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": ["SAST", "SCA", "IaC", "Secrets"],
        "toolType":"paid",
        "icon": "/images/qwietai.svg",
        showScanButton: false,
        ConfigComponent: QwietAIPullAndPushView,
    },
    {
        id: "DEPENDENCY_TRACK",
        name: "Dependency Track",
        isActive: true,
        toolType:"open",
        showScanButton: false,
        showAddButton: false,
        category: ['SCA'],
        icon: "/images/dependency-track.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: DependencyTrackPullAndPushView,
        ModalFormComponent: DependencyTrackCredentialsForm,
    },
    {
        id: "CYCLONEDX",
        name: "CycloneDX",
        toolType: "open",
        scanName: "CycloneDX",
        icon: "/images/cyclone-dx.svg",
        category: ['SBOM'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        "id": "NEXPOSE",
        "name": "Rapid7 nexpose",  
        "isActive": true,
        "toolType":"paid",
        category: ['Infrastructure Tools'],
        "icon": "/images/nexpose.png",
        showScanButton: false,
        ConfigComponent: NexposePullAndPushView
    },{
        id: "DEPENDABOT",
        name: "Dependabot",
        displayName: "GitHub Dependabot",
        toolType: "open",
        "icon": "/images/github.svg",
        category: ['SCA', 'SBOM'],
        "isActive": true,
        ConfigComponent: DependabotPullAndPushView,
        ToolSettingsComponent: DependabotSyncPRsConfig,
        isBidirectionalTool: true,
        bidirectionalStatusSupport:false,
        bidrectionalFeatureKey : "GITHUB_BIDIRECTION_SUPPORT",
        showScanButton: false,
    },
    {
        id: "GITHUB_CODE_SCAN",
        name: "Github Code Scan",
        displayName: "GitHub Code Scan",
        toolType: "open",
        icon: "/images/github.svg",
        category: ['SAST'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: GithubCodeScanPullAndPushView,
        ModalFormComponent: GithubCodeScanCredentialsForm,
        isBidirectionalTool:true,
        bidirectionalStatusSupport:false,
        bidrectionalFeatureKey : "GITHUB_BIDIRECTION_SUPPORT",
    },
    {
        "id": "SONARCLOUD",
        "name": "Sonarcloud",
        "isActive": true,
        "toolType":"open",
        "category": ["SAST"],
        "description": "SonarCloud is a cloud-based code quality and security service.",
        "icon": "/images/SonarCloud.svg",
        showScanButton: false,
        ConfigComponent: SonarcloudPullAndPushView,
    },
    {
        "id": "GOOGLE_CLOUD_REGISTRY",
        "name": "Google Cloud Registry",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Container Security",
        "toolType":"paid",
        "tags": [
            "Java",
            "C#",
            "VB.net",
            "PHP",
            "JS"
        ],
        "icon": "/images/googleCloud.svg",
        ConfigComponent: GoogleCloudRegistryPullAndPushView,
    },
    {
        "id": "GOOGLE_SECURITY_COMMAND_CENTER",
        "name": "Google Security Command Center",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        hidePushView:true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "icon": "/images/google-security-command-center.svg",
        ConfigComponent: GoogleSecurityCommandCenterPullAndPushView,
    },
    {
        "id": "VM_SECURESTATE",
        "name": "VM SecureState",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "icon": "/images/cloudhealth.svg",
        ConfigComponent: VMSecureStatePullAndPushView,
    },
    {
        id: "AVOCADO",
        name: "Avocado",
        isActive: true,
        toolType: "paid",
        showScanButton: false,
        showAddButton: false,
        category: ['Threat Model'],
        icon: "/images/Avocado.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "LACEWORK",
        name: "Lacework",
        isActive: true,
        toolType: "paid",
        showScanButton: false,
        showWebHookView: true,
        showOnlyToken: true,
        showAddButton: false,
        webHookInfo: "Webhook scan trigger after 1 hour",
        category: ["CSPM", "Container Security", "Infrastructure Tools"],
        icon: "/images/Lacework.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: LaceworkPullAndPushView,
        WebhookSuccessComponent: LaceWorkWebhookSuccessPopup,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "Sonatype_Lifecycle",
        name: "Sonatype Lifecycle",
        toolType: "paid",
        "icon": "/images/Sonatype_Lifecycle.svg",
        category: ['SCA',"SBOM","License"],
        "isActive": true,
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: SonatypeLifecyclePullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "MAGENTO",
        name: "Magento",
        isActive: true,
        toolType: "open",
        showScanButton: false,
        showAddButton: false,
        category: ['DAST'],
        icon: "/images/Magento.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "RAPID7_INSIGHT",
        name: "Rapid7 Insight",
        isActive: true,
        toolType: "paid",
        showScanButton: false,
        showAddButton: false,
        category: ["DAST"],
        icon: "/images/Rapid7_Insight.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: Rapid7InsightPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "KICS",
        name: "Kics",
        isActive: true,
        toolType: "open",
        showScanButton: false,
        showAddButton: false,
        category: ["IaC"],
        icon: "/images/kics.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
        allowZip: true
    },
    {
        "id": "tenable_webapp",
        "name": "Tenable Webapp",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "description": "Tenable Webapp is a DAST tool",
        "icon": "/images/nessus.png",
        ConfigComponent: TenableWebappPullAndPushView
    },
    {
        "id": "tenable_infrastructure",
        "name": "Tenable Infrastructure",
        displayName: "Tenable Infrastructure (Deprecated)",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "description": "Tenable Infrastructure is a DAST tool",
        "icon": "/images/nessus.png",
        ConfigComponent: TenableInfraPullAndPushView,
        MappingForm: TenableInfraMappingForm,
        featureKey: "TENABLE_INFRASTRUCTURE_DEPRECATED"
    },
    {
        "id": "TENABLE_SC",
        "name": "Tenable.sc",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "description": "Tenable.sc is a DAST tool",
        "icon": "/images/nessus.png",
        ConfigComponent: TenableScPullAndPushView,
    },
    {
        "id": "TENABLE_VULNERABILITY_MANAGEMENT",
        "name": "Tenable Vulnerability Management",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Infrastructure Tools", "Asset Management"],
        "toolType":"paid",
        "icon": "/images/nessus.png",
        ConfigComponent: TenableVulnerabilityManagementPullAndPushView,
        ModalFormComponent: TenableVulnerabilityManagementCredentialsForm,
    },
    {
        "id": "YARN_AUDIT",
        "name": "Yarn Audit",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SCA",
        "toolType":"open",
        "icon": "/images/yarn-appsec.svg",
        "description": "Yarn Audit",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
        allowZip: true
    },
    {
        "id": "BUNDLER_AUDIT",
        "name": "Bundler Audit",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SCA",
        "toolType":"open",
        "icon": "/images/Bundler.svg",
        "description": "Bundler Audit",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
        allowZip: true
    },
    {
        "id": "WIZ",
        "name": "Wiz",
        "isActive": true,
        "category": ["CSPM", "Infrastructure Tools", "Container Security", "Data Security", "Asset Management","External Attack Surface Management","Secrets"],
        "toolType":"paid",
        "description": "Wiz is a CSPM tool",
        "icon": "/images/Wiz.svg",
        showWebHookView: true,
        webHookInfo: "Webhook scan trigger after 1 hour",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: WizPullAndPushView,
        ModalFormComponent: WizCredentialsForm,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: false
    },
    {
        "id": "SCOUT_SUITE",
        "name": "Scout Suite",
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "description": "Scout Suite is a infrastructure tool",
        "icon": "/images/ScoutSuite.svg",
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
        allowZip:true
    },
    {
        "id": "LGTM",
        "name": "LGTM",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SAST",
        "toolType":"open",
        "icon": "/images/LGTM.svg",
        "description": "LGTM is a SAST tool",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "CHECKOV",
        "name": "Checkov",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SCA", "Secrets"],
        "toolType":"open",
        "icon": "/images/Checkov.svg",
        "description": "Checkov is a SCA tool",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "SEMGREP",
        "name": "Semgrep",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SAST", "SCA", "Secrets","SBOM"],
        "toolType":"open",
        "icon": "/images/semgrep.svg",
        "description": "Semgrep is a SAST tool",
        ConfigComponent: SemgrepPullAndPushView,
        MappingForm: SemgrepMappingForm,
        ModalFormComponent: SemgrepCredentialsForm,
        isBidirectionalTool: true
    },
    {
        id: "Bridgecrew",
        name: "Bridgecrew",
        toolType: "open",
        icon: "/images/Bridgecrew.svg",
        category: ['CSPM', 'SAST', 'SCA', 'IaC', 'Secrets'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: BridgecrewPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "SecurityScorecard",
        name: "SecurityScorecard",
        toolType: "paid",
        icon: "/images/SecurityScorecard.svg",
        category: ["External Attack Surface Management"],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: SecurityScorecardPullAndPushView,
        MappingForm: SecurityScorecardMappingForm,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "AMAZON_GUARDDUTY",
        "name": "Amazon GuardDuty",
        showScanButton: false,
        showAddButton: false,
        showWebHookView: true,
        webHookInfo: "Webhook scan trigger after 1 hour",
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "icon": "/images/Guardduty.svg",
        showOnlyToken: true,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        WebhookSuccessComponent: GuardDutyWebhookSuccessPopup,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "amazon_inspector",
        "name": "Amazon Inspector",
        showScanButton: false,
        showAddButton: false,
        showWebHookView: true,
        deprecateWebhook: true,
        webHookInfo: "Webhook scan trigger after 1 hour",
        showOnlyToken: true,
        "isActive": true,
        "category": "Infrastructure Tools",
        "toolType":"paid",
        "icon": "/images/Inspector.svg",
        "description": "Amazon Inspector is an Infrastructure tool",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: AmazonInspectorPullAndPushView,
        WebhookSuccessComponent: AmazonInspectorWebhookSuccessPopup,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "Burpsuite Enterprise",
        name: "Burpsuite Enterprise",
        toolType: "paid",
        isActive: true,
        category: "DAST",
        description: "Burp is a web application security testing tool",
        icon: "/images/Burp_Enterprise.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: BurpsuiteEnterprisePullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "Orca Security",
        name: "Orca Security",
        toolType: "paid",
        isActive: true,
        category: ["CSPM", "Asset Management"],
        icon: "/images/Orca.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: OrcaSecurityPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Edgescan",
        name: "Edgescan",
        toolType: "paid",
        isActive: true,
        category: ["DAST", "Pentesting Framework"],
        icon: "/images/edgescan.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: EdgescanPullAndPushView,
        MappingForm: EdgescanMappingForm,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "NodeZero",
        name: "NodeZero",
        displayName: "Horizon3.ai NodeZero",
        toolType: "paid",
        isActive: true,
        category: "Pentesting Framework",
        icon: "/images/nodeZero.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: NodeZeroPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "WhiteHat Sentinel",
        name: "WhiteHat Sentinel",
        toolType: "paid",
        isActive: true,
        category: ["SCA","SAST","DAST"],
        icon: "/images/whitehat.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: WhiteHatSentinelPullAndPushView,
        MappingForm: WhiteHatSentinelMappingForm,
    },
    {
        id: "wallarm",
        name: "Wallarm",
        showScanButton: false,
        showAddButton: false,
        isActive: true,
        toolType:"paid",
        category: "API Security",
        icon: "/images/wallarm.svg",
        hidePushView: true,
        ConfigComponent: WallarmPullAndPushView,
        ModalFormComponent: WallarmCredentialForm,
    },
    {
        id: "GITGUARDIAN",
        name: "GitGuardian",
        category: ["SAST", "Secrets"],
        integrationType: IntegrationType.PULL,
        showScanButton: false,
        showAddButton: false,
        toolType: "all",
        isActive: true,
        icon: "/images/gitguardian.svg",
        isBidirectionalTool: true,
        bidrectionalFeatureKey: "GITGUARDIAN_OCCURRENCE_BASED_FINDINGS",
        invertFlag: true,
        ConfigComponent: GitGuardianPullAndPushView,
        ModalFormComponent: GitGuardianCredentialsForm
    },
    {
        "id": "Appknox",
        "name": "Appknox",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": "MAST",
        "toolType":"paid",
        "icon": "/images/appknox.svg",
        showScanButton: false,
        hidePushView: true,
        ConfigComponent: AppknoxPullAndPushView
    },{
        id: "SAFETY",
        name: "Safety",
        category: "SCA",
        showScanButton: false,
        showAddButton: false,
        toolType:"open",
        isActive: true,
        icon: "/images/safety.svg",
        description: "Safety is a SCA tool",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Rapid7 InsightVM",
        name: "Rapid7 InsightVM",
        toolType: "paid",
        isActive: true,
        category: ["Infrastructure Tools", "Asset Management"],
        icon: "/images/Rapid7_Insight.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: Rapid7InsightVMPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "Gosec Scanner",
        name: "Gosec Scanner",
        isActive: true,
        category: "SAST",
        toolType:"open",
        icon: "/images/gosec-scanner-appsec.png",
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Tanium",
        name: "Tanium",
        toolType: "paid",
        isActive: true,
        category: "Infrastructure Tools",
        icon: "/images/tanium.svg",
        showScanButton: false,
        showAddButton: false,
        showWebHookView: true,
        ConfigComponent:TaniumPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Salt Security",
        name: "Salt Security",
        category: "API Security",
        isActive: true,
        icon: "/images/salt.svg",
        toolType:"paid",
        showScanButton: false,
        showAddButton: false,
        showWebHookView: true,
        webHookInfo: "Webhook scan trigger after 1 hour",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Grammatech - CodeSentry",
        name: "Grammatech - CodeSentry",
        category: ["SCA"],
        isActive: true,
        toolType: "paid",
        icon: "/images/grammatech.svg",
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GrammatechCodeSentryPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Grammatech - CodeSonar",
        name: "Grammatech - CodeSonar",
        category: ["SAST"],
        isActive: true,
        toolType: "paid",
        icon: "/images/grammatech.svg",
        showScanButton: false,
        showAddButton: false,
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GrammatechCodeSonarPullAndPushView,
        ModalFormComponent: IngestionScriptFormPopup,
    },{
        id: "Traceable",
        name: "Traceable",
        category: ["API Security"],
        isActive: true,
        toolType:"paid",
        icon: "/images/traceable.svg",
        showScanButton: false,
        showAddButton: false,
        isBidirectionalTool:true,
        ConfigComponent: TraceablePullAndPushView,
        ModalFormComponent: TraceableCredentialForm
    },
    {
        id: "Checkmarx SCA",
        name: "Checkmarx SCA",
        showScanButton: false,
        category: ["SCA"],
        showAddButton: false,
        toolType:"paid",
        icon: "/images/checkmarx sca.svg", 
        ConfigComponent: CheckmarxSCAPullandPushView,
        ModalFormComponent: CheckmarxSCACredentialForm,
        isActive: true,
    },
    {
        id: "SONRAI_SECURITY",
        name: "Sonrai Security",
        toolType: "paid",
        isActive: true,
        category: "CSPM",
        icon: "/images/sonrai.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: SonraiPullAndPushView,
        ModalFormComponent: SonraiCredentialForm,
    },
    {
        id: "Data Theorem",
        name: "Data Theorem",
        isActive: true,
        icon: "/images/data theorem.svg",
        toolType: "paid",
        showScanButton: false,
        showAddButton: false,
        category: ["SAST", "DAST", "IAST", "RASP", "MAST"],
        ConfigComponent: DataTheoremPullAndPushView,
        ModalFormComponent: DataTheoremCredentialForm
    },
    {
        id: "Cloud Optix",
        name: "Cloud Optix",
        showScanButton: false,
        showAddButton: false,
        icon: "/images/cloud optix.svg",
        isActive: true,
        toolType: "paid",
        category: ["CSPM"],
        ConfigComponent: CloudOptixPullAndPushView,
        ModalFormComponent: CloudOptixCredentialForm
    },
    {
        id: "CrowdStrike Falcon",
        name: "CrowdStrike Falcon",
        toolType: "paid",
        isActive: true,
        category: ["Infrastructure Tools", "Container Security", "CSPM", "IaC", "Asset Management"],
        icon: "/images/crowdstrike falcon.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: CrowdStrikeSpotlightPullAndPushView,
        ModalFormComponent: CrowdStrikeSpotlightCredentialsForm,
        ToolSettingsComponent: GenericSyncPRsConfig,
    },
    {
        "id": "sysDig",
        "name": "SysDig",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["CSPM", "Container Security"],
        "toolType":"paid",
        "icon": "/images/sysdig.svg",
        ConfigComponent: SysDigPullAndPushView
    },
    {
        id: "Stackhawk",
        name: "Stackhawk",
        toolType:"paid",
        isActive: true,
        category: "DAST",
        icon: "/images/stackhawk.svg",
        ConfigComponent: StackhawkPullAndPushView,

    },
    {
        id: "GITHUB_SECRET_SCAN",
        name: "Github Secret Scan",
        displayName: "GitHub Secret Scan",
        isActive: true,
        category: ["SAST", "Secrets"],
        toolType:"open",
        icon: "/images/github.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: GithubSecretScanPullAndPushView,
        ModalFormComponent: GithubSecretScanCredentialsForm,
        isBidirectionalTool:true,
        bidirectionalStatusSupport:false,
        bidrectionalFeatureKey : "GITHUB_BIDIRECTION_SUPPORT",
    },
    {
        id: "Checkmarx One",
        name: "Checkmarx One",
        icon: "/images/checkmarx one.svg",
        isActive: true,
        toolType:"paid",
        category: ["SAST", "IaC", "SCA", "Secrets", "SBOM"],
        categoryFeatureFlag: {
            "CX_ONE_CONTAINER_SECURITY_INGESTION": ["Container Security"],
        },
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: CheckmarxOnePullAndPushView,
        ModalFormComponent: CheckmarxOneCredentialForm,
        isBidirectionalTool: true,
    },
    {
        id: "Grype",
        name: "Grype",
        icon: "/images/grype.svg",
        isActive: true,
        category: "Container Security",
        showScanButton: false,
        showAddButton: false,
        toolType:"open",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "VDOO",
        name: "JFrog Vision (Vdoo)",
        isActive: true,
        category: "SCA",
        toolType:"paid",
        icon: "/images/jfrog vision (vdoo).svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: VdooPullAndPushView,
        ModalFormComponent: VdooCredentialsForm,
        featureKey: 'JFROG_VISION_VDOO'
    },
    {
        id: "Probely",
        name: "Probely",
        icon: "/images/probely.svg",
        isActive: true,
        toolType:"paid",
        category: "DAST",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: ProbelyPullAndPushView,
        ModalFormComponent: ProbelyCredentialsForm 
    },
     {
        id: "HashiCorp Vault Radar",
        name: "HashiCorp Vault Radar",
        isActive: true,
        category: ["SAST", "Secrets"],
        toolType:"open",
        icon: "/images/HcpVaultRadar.svg",
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: HashiCorpVaultRadarPullAndPushView,
        ModalFormComponent: HashiCorpVaultRadarCredentialsForm
    }, {
        id: "RunZero",
        name: "RunZero",
        icon: "/images/runzero.png",
        isActive: true,
        toolType:"paid",
        category: ["Infrastructure Tools", "Asset Management"],
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: RunZeroPullAndPushView,
        ModalFormComponent: RunZeroCredentialsForm
    },
    {
        id: "MERGEBASE",
        name: "Mergebase",
        description: "Mergebase",
        icon: "/images/Mergebase.png",
        toolType:"paid",
        category: ['SCA'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: MergeBasePullAndPushView,
        ModalFormComponent: MergeBaseCredentialsForm
    },
    {
        "id": "trivy",
        "name": "Trivy",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Container Security", "SCA", "Secrets", "SAST"],
        "toolType":"open",
        "icon": "/images/trivy.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "FINITESTATE",
        name: "FiniteState",
        integrationType: IntegrationType.PULL,
        isActive: true,
        category: ["SCA","SAST"],
        toolType:"paid",
        icon: "/images/finitestate.png",
        showScanButton: false,
        ConfigComponent: FiniteStatePullAndPushView
    },
    {
        "id": "klocwork",
        "name": "Klocwork",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SAST",
        "toolType":"open",
        "icon": "/images/klocwork.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "SPECTRAL",
        name: "Spectral",
        description: "Spectral",
        icon: "/images/spectral.svg",
        category: ['SAST', 'IaC', 'Secrets'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: SpectralPullAndPushView,
        ModalFormComponent: SpectralCredentialsForm
    },
    {
        id: "SEEKER",
        name: "Seeker",
        description: "Seeker",
        icon: "/images/seeker.svg",
        toolType:"paid",
        category: ['IAST'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: SeekerPullAndPushView,
        ModalFormComponent: SeekerCredentialsForm
    },
    {
        id: "Clayton",
        name: "Clayton",
        icon: "/images/clayton.svg",
        isActive: true,
        category: "SAST",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: ClaytonPullAndPushView,
        ModalFormComponent: ClaytonCredentialsForm   
    },
    {
        id: "APIIRO",
        name: "Apiiro",
        description: "Apiiro",
        icon: "/images/apiiro.svg",
        toolType:"paid",
        category: ['SAST', 'SCA', 'IaC'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: ApiiroPullAndPushView,
        ModalFormComponent: ApiiroCredentialForm
    }, 
    {
        id: "Coverity on Polaris",
        name: "Coverity on Polaris",
        icon: "/images/polaris.svg",
        isActive: true,
        category: "SAST",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: PolarisPullAndPushView,
        ModalFormComponent: PolarisCredentialsForm,
    },
    {
        "id": "CORTEX_XDR",
        "name": "Cortex XDR",
        icon:"/images/cortex-xdr.svg",
        "isActive": true,
        "category": ["Infrastructure Tools", "Asset Management"],
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: CortexPullAndPushView,
        ModalFormComponent: CortexCredentialsForm,
        MappingForm: CortexMappingForm
    },
    {
        id: "IriusRisk",
        name: "IriusRisk",
        icon: "/images/iriusrisk.svg",
        isActive: true,
        category: "Threat Model",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: IriusRiskPullAndPushView,
        ModalFormComponent: IriusRiskCredentialsForm,
        isBidirectionalTool:true,
        bidirectionalStatusSupport:true,
        // featureKey: "IRIUS_RISK_FETCH_FROM_V2_API",
        bidrectionalFeatureKey : "IRIUS_RISK_FETCH_FROM_V2_API",
    },
    {
        "id": "SD_ELEMENTS",
        "name": "SD Elements",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": "Threat Model",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: SDElementsPullAndPushView,
        MappingForm: SDElementsMappingForm,
        ModalFormComponent: SDElementsCredentialsForm,
        icon: "/images/sdelements.svg",
    },
    {
        id: "Meterian",
        name: "Meterian",
        icon: "/images/meterian.svg",
        isActive: true,
        category: "SCA",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: MeterianPullAndPushView,
        ModalFormComponent: MeterianCredentialsForm, 
    },
    {
        id: "TenableCloudSecurity",
        name: "Tenable Cloud Security",
        icon: "/images/nessus.png",
        isActive: true,
        category: "CSPM",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: TenableCloudSecurityPullAndPushView,
        ModalFormComponent: TenableCloudSecurityCredentialsForm,
    },
    {
        id: "Redhat ACS",
        name: "Redhat ACS",
        icon: "/images/redhat acs.svg",
        isActive: true,
        "category": "Container Security",
        showScanButton: false,
        showAddButton: false,
        "toolType":"open",
        ConfigComponent: RedhatACSPullAndPushView,
        ModalFormComponent: RedhatACSCredentialsForm,
    },
    {
        id: "Halo Security",
        name: "Halo Security",
        icon: "/images/halo security.svg",
        isActive: true,
        "category": "DAST",
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: HaloSecurityPullAndPushView,
        ModalFormComponent: HaloSecurityCredentialsForm,
    },
    {
        id: "Cycode",
        name: "Cycode",
        icon: "/images/cycode.svg",
        isActive: true,
        categoryFeatureFlag: {
            "CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS": ["CSPM", "Container Security"],
        },
        "category": ["SAST", "SCA", "Secrets", "Data Security"],
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: CycodePullAndPushView,
        ModalFormComponent: CycodeCredentialsForm,
    },
    {
        id: "Gitlab Security",
        name: "Gitlab Security",
        "icon": "/images/gitlabcicd.svg",
        isActive: true,
        "category": ["SAST", "Secrets", "DAST", "SCA", "Container Security", "IaC", "API Fuzzing"],
        showScanButton: false,
        showAddButton: false,
        "toolType":"open",
        pushScriptInfo: "Please make sure the file being pushed just has 1 scan type across all the findings.",
        scanInfo: "Please make sure the file being uploaded just has 1 scan type across all the findings.",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GitlabSecurityPullAndPushView,
        ModalFormComponent: GitlabSecurityCredentialsForm,
    },
    {
        id: "Deepfence",
        name: "Deepfence",
        "icon": "/images/deepfence.svg",
        isActive: true,
        "category": ["Infrastructure Tools"],
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: DeepfencePullAndPushView,
        ModalFormComponent: DeepfenceCredentialsForm,
    },
    {
        id: "Mend.io",
        name: "Mend.io",
        description: "Mend.io",
        icon: "/images/mendIO.svg",
        toolType:"paid",
        category: ['SAST'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: MendIOPullAndPushView,
        ModalFormComponent: MendIOCredentialsForm,
    },
    {
        id: "Microsoft Defender for Cloud",
        name: "Microsoft Defender for Cloud",
        description: "Microsoft Defender for Cloud",
        icon: "/images/ms defender cloud.svg",
        toolType:"paid",
        category: ['CSPM', "Asset Management"],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: MicrosoftDefenderPullAndPushView,
        ModalFormComponent: MicrosoftDefenderCredentialsForm
    },
    {
        id: "UpGuard",
        name: "UpGuard",
        description: "UpGuard",
        icon: "/images/Upguard.svg",
        toolType:"paid",
        category: 'Threat Intelligence',
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: UpGuardPullAndPushView,
        ModalFormComponent: UpGuardCredentialsForm,
        MappingForm: UpGuardMappingForm
    }, {
        id: "BitSight",
        name: "BitSight",
        "icon": "/images/bitsight.svg",
        isActive: true,
        "category": ["External Attack Surface Management"],
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: BitSightPullAndPushView,
        ModalFormComponent: BitSightCredentialsForm
    },
    {
        id: "42Crunch",
        name: "42Crunch",
        icon: "/images/Crunch.svg",
        category: 'API Security',
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        "toolType":"paid",
        ConfigComponent: Crunch42PullAndPushView,
        ModalFormComponent: Crunch42CredentialsForm
    },
    {
        "id": "Microsoft Defender for Endpoint",
        "name": "Microsoft Defender for Endpoint",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Infrastructure Tools", "Asset Management"],
        "toolType":"paid",
        "icon": "/images/microsoft defender for endpoint.svg",
        ConfigComponent: MicrosoftDefenderForEndPointPullAndPushView,
        ModalFormComponent: MicrosoftDefenderForEndpointCredentialsForm
    },
    {
        "id": "SentinelOne",
        "name": "SentinelOne",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Endpoint Vulnerability Management",
        "toolType":"paid",
        "icon": "/images/sentinelone.svg",
        ConfigComponent: SentinelOnePullAndPushView,
        ModalFormComponent: SentinelOneCredentialsForm
    },
    {
        id: "Noname",
        name: "Noname",
        description: "No Name Security Tool",
        icon: "images/noname.svg",
        toolType:"paid",
        category: ['API Security', 'DAST'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: NonamePullAndPushView,
        ModalFormComponent: NonameCredentialsForm,
    },
    {
        "id": "Polyspace",
        "name": "Polyspace",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SAST",
        "toolType":"open",
        "icon": "/images/polyspace.svg", 
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup, 
    },
    {
        "id": "AppCheck",
        "name": "AppCheck",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"paid",
        "icon": "/images/appcheck.svg",
        ConfigComponent: AppcheckPullAndPushView,
        ModalFormComponent: AppcheckCredentialsForm,
        isBidirectionalTool: true,
    },
    {
        "id": "Endor Labs",
        "name": "Endor Labs",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SCA", "Secrets", "License", "Container Security", "SAST", "Misconfiguration"],
        "toolType":"paid",
        "icon": "/images/endorlabs.svg",
        ConfigComponent: EndorLabsPullAndPushView,
        ModalFormComponent: EndorLabsCredentialsForm,
    },
    {
        "id": "Legitify",
        "name": "Legitify",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "SCM",
        "toolType":"paid",
        "icon": "/images/legitify.svg",
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        id: "Docker Scout",
        name: "Docker Scout",
        showScanButton: false,
        showAddButton: false,
        isActive: true,
        category: ["Container Security"],
        toolType: "open",
        icon: "/images/docker scout.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView: true,
        ModalFormComponent: IngestionScriptFormPopup,
      },
      {
        "id": "WPScan",
        "name": "WPScan",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "DAST",
        "toolType":"open",
        "icon": "/images/wpscan.svg", 
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        showWebHookView: true,
        ModalFormComponent: IngestionScriptFormPopup, 
      },
      {
        id: "RiskRecon",
        name: "RiskRecon",
        icon: "images/riskrecon.svg",
        toolType:"paid",
        category: ['TPRM'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: RiskReconPullAndPushView,
        ModalFormComponent: RiskReconCredentialsForm,
    },
    {
        id: "Prowler",
        name: "Prowler",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        toolType:"open",
        category: "CSPM",
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: GenericPullAndPushToolView,
        ModalFormComponent: IngestionScriptFormPopup,
        hidePullView: true,
        icon: "/images/prowler.svg"
      },
      {
        id: "Privado",
        name: "Privado",
        icon: "images/privado.svg",
        toolType:"paid",
        category: ['Privacy Impact Assessment'],
        isActive: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: PrivadoPullAndPushView,
        ModalFormComponent: PrivadoCredentialsForm
    },
    {
        "id": "Oligo Security",
        "name": "Oligo Security",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "Container Security",
        "toolType":"paid",
        "icon": "/images/Oligo.svg",
        ConfigComponent: OligoPullAndPushView,
        ModalFormComponent: OligoCredentialsForm,
    },
    {
        "id": "Orca Security Shiftleft",
        "name": "Orca Security Shiftleft",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SCA", "IaC", "Secrets","Container Security", "SAST","Misconfiguration","License"],
        "toolType":"paid",
        "icon": "/images/Orca.svg",
        ConfigComponent: OrcaSecurityShiftLeftPullAndPushView,
        ModalFormComponent: OrcaSecurityShiftLeftCredentialsForm,
    },
    {
        "id": "AppSentinels",
        "name": "AppSentinels",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": "API Security",
        "toolType":"paid",
        "icon": "/images/appsentinels.svg",
        ConfigComponent: AppSentinelsPullAndPushView,
        ModalFormComponent: AppSentinelsCredentialForm,
        isBidirectionalTool: true,
        bidirectionalStatusSupport: true,
    },
    {
        "id": "Synopsys Polaris",
        "name": "Synopsys Polaris",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["SAST", "SCA"],
        "toolType":"paid",
        "icon": "/images/synopsys polaris.svg",
        ConfigComponent: SynopsysPolarisPullAndPushView,
        ModalFormComponent: SynopsysPolarisCredentialsForm,
    }, 
    {
        "id": "jira",
        "name": "Jira",
        integrationType: IntegrationType.PULL,
        "isActive": true,
        "category": ["Custom", "Asset Management"],
        "toolType":"paid",
        "icon": "/images/jira.svg",
        showScanButton: false,
        hidePushView: true,
        // listingAPI: ToolsIntegrationsAPI.getGenericConfigurationsByToolName,
        // deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        // suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: JiraPullView,
    },{
        "id": "Socket.dev",
        "name": "Socket.dev",
        showScanButton: true,
        showAddButton: true,
        "isActive": true,
        "category": ["SCA"],
        "toolType":"paid",
        "icon": "/images/socketDev.png",
        ConfigComponent: SocketDevPullAndPushView,
        ModalFormComponent: SocketDevCredentialsForm,
    },
    {
        "id": "Rapid7 Insight Cloud Security",
        "name": "Rapid7 Insight Cloud Security",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["CSPM"],
        "toolType":"paid",
        icon: "/images/Rapid7_Insight.svg",
        ConfigComponent: Rapid7InsightCloudPullAndPushView,
        ModalFormComponent: Rapid7InsightCloudCredentialsForm,
    },{
        "id": "Acunetix Premium",
        "name": "Acunetix Premium",
        "isActive": true,
        "category": ["DAST"],
        "toolType":"paid",
        "icon": "/images/acunetix-premium.png",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: AcunetixPremiumPullAndPushView,
        ModalFormComponent: AcunetixPremiumCredentialsForm,
    },{
        "id": "Cybeats",
        "name": "Cybeats",
        "isActive": true,
        "category": ["SBOM"],
        "toolType":"paid",
        "icon": "/images/cybeats.svg",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: CybeatsPullAndPushView,
        ModalFormComponent: CybeatsCredentialsForm,
    },
    {
        "id": "trufflehog",
        "name": "TruffleHog",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Secrets"],
        "toolType":"open",
        "icon": "/images/trufflehog.svg",
        deleteAPI: ToolsIntegrationsAPI.deleteGenericConfigurationByToolName,
        suspendAPI: ToolsIntegrationsAPI.updateGenericConfigurationByToolName,
        ConfigComponent: GenericPullAndPushToolView,
        hidePullView:true,
        ModalFormComponent: IngestionScriptFormPopup,
    },
    {
        "id": "Prisma Cloud Compute",
        "name": "Prisma Cloud Compute",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Container Security", "SCA", "SAST", "IaC", "Infrastructure Tools", "Secrets", "Asset Management", "API Security"],
        "toolType":"paid",
        icon: "/images/prisma cloud compute.svg",
        ConfigComponent: PrismaCloudComputePullAndPushView,
        ModalFormComponent: PrismaCloudComputeCredentialsForm,
    },
    {
    
        "id": "Qualys Container Security",
        "name": "Qualys Container Security",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Container Security"],
        "toolType":"paid",
        "icon": "/images/qualys container security.svg",
        ConfigComponent: QualysContainerSecurityPullAndPushView,
        ModalFormComponent: QualysContainerSecurityCredentialsForm,
    },
    {
        "id": "Upwind",
        "name": "Upwind",
        "isActive": true,
        "category": ["CSPM", "Asset Management"],
        "toolType":"paid",
        "icon": "/images/Upwind.svg",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: UpwindPullAndPushView,
        ModalFormComponent: UpwindCredentialsForm,
    },
    {
        "id": "Qualys Policy Compliance",
        "name": "Qualys Policy Compliance",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        "category": ["Infrastructure Tools"],
        "toolType":"paid",
        "icon": "/images/qualys-policy-compliance.svg",
        ConfigComponent: QualysPolicyCompliancePullAndPushView,
        ModalFormComponent: QualysPolicyComplianceCredentialsForm,
    },
    {
        "id": "Arnica",
        "name": "Arnica",
        "isActive": true,
        "category": ["SAST","SCA","IaC","Reputation","License","Secrets"],
        "toolType": "open",
        "icon": "/images/arnica.png",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: ArnicaPullAndPushView,
        ModalFormComponent: ArnicaCredentialsForm,
    },
     {
        id: "Reversing Labs Spectra Assure",
        name: "Reversing Labs Spectra Assure",
        showScanButton: false,
        showAddButton: false,
        isActive: true,
        toolType:"paid",
        category: ["SCA","Malware","Secrets"],
        icon: "/images/Reversing Labs.svg",
        hidePushView: true,
        ConfigComponent: ReversingLabSpectraPullAndPushView,
        ModalFormComponent: ReversingLabSpectraCredentialsForm,
    },
    {
        id: "ThreatModeler",
        name: "ThreatModeler",
        isActive: true,
        category: ["Threat Model"],
        toolType: "paid",
        icon: "/images/threatmodeler.svg",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: ThreatModelerPullAndPushView,
        ModalFormComponent: ThreatModelerCredentialsForm,
    },
    {
        id: "Pentest Tools",
        name: "Pentest Tools",
        showScanButton: false,
        showAddButton: false,
        isActive: true,
        toolType:"paid",
        category: ["DAST"],
        icon: "/images/Pen-test Tool.svg",
        hidePushView: true,
        ConfigComponent: PenTestToolPullAndPushView,
        ModalFormComponent: PenTestToolCredentialsForm,
    },
    {
        "id": "Axonius",
        "name": "Axonius",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        hidePushView: true,
        category: ["Infrastructure Tools", "Asset Management"],
        "toolType":"buildTools",
        "icon": "/images/axonius.svg",
        ConfigComponent: AxoniusPullAndPushView,
        ModalFormComponent: AxoniusCredentialsForm,
    },
    {
        "id": "Blackduck Binary Analysis",
        "name": "Blackduck Binary Analysis",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        hidePushView: true,
        category: ["SCA"],
        toolType:"paid",
        icon: "/images/blackduck binary analysis.jpeg",
        ConfigComponent: BlackduckBinaryAnalysisPullAndPushView,
        ModalFormComponent: BlackduckBinaryAnalysisCredentialsForm,
    },
    {
        "id":"Ostorlab",
        "name":"Ostorlab",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        hidePushView: true,
        category: ["MAST"],
        toolType:"paid",
        icon: "/images/Ostorlab.svg",
        ConfigComponent: OstorlabPullAndPushView,
        ModalFormComponent: OstorlabCredentialsForm,
    },
    {
        "id":"HCL AppScan Enterprise",
        "name":"HCL AppScan Enterprise",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        category: ["DAST"],
        toolType:"paid",
        icon: "/images/appscan-appsec.svg",
        ConfigComponent: HCLAppscanPullAndPushView,
        ModalFormComponent: HCLAppscanCredentialsForm,
    },{
        "id":"HCL AppScan on Cloud",
        "name":"HCL AppScan on Cloud",
        showScanButton: false,
        showAddButton: false,
        "isActive": true,
        category: ["SAST", "DAST", "SCA", "IAST"],
        toolType:"paid",
        icon: "/images/appscan-appsec.svg",
        ConfigComponent: HCLAppscanCloudPullAndPushView,
        ModalFormComponent: HCLAppscanCloudCredentialsForm,
    },{
        "id": "APISec",
        "name": "APISec",
        "isActive": true,
        "category": ["API Security"],
        "toolType":"paid",
        "icon": "/images/apisec.svg",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: ApiSecPullAndPushView,
        ModalFormComponent: ApiSecCredentialsForm,
    },
    {
        "id": "UltraViolet",
        "name": "UltraViolet",
        "isActive": true,
        "category": ["Pentesting Framework"],
        "toolType":"paid",
        "icon": "/images/ultraviolet.svg",
        hidePushView: true,
        showScanButton: false,
        showAddButton: false,
        ConfigComponent: UltraVioletPullAndPushView,
        ModalFormComponent: UltraVioletCredentialsForm,
    },
].sort(Sorters.STRING("name")));

export { SecurityToolsData as ToolsData, IntegrationToolsData }

export function getToolsWithCategory() {
    return SecurityToolsData.map(tool => {
        return {
            label: `${tool.name} - ${_.isArray(tool.category) ? tool.category.join(', ') : tool.category}`,
            value: tool.name
        }
    })
}

export const getEnvSelectOptions = (array) => array.map(option => ({ label: <EnvironmentName name={option.name} />, value: option.name }));
  
export const getTicketSystemName = (ticketSystemType) => {
    if (!ticketSystemType) return "";
    if (TICKET_SYSTEM_TYPE_DISPLAY_TEXT[ticketSystemType]) { return TICKET_SYSTEM_TYPE_DISPLAY_TEXT[ticketSystemType] }
    const toolData = _.find(IntegrationToolsData, (item) => item.name?.toUpperCase().replaceAll(" ", "_") === ticketSystemType)
    return toolData.displayName || _.startCase(_.toLower(ticketSystemType))
};

export const SCMTools = IntegrationToolsData.filter(
    (tool) =>
        tool.category?.includes("Repository") || tool.category === "Repository",
);

export const CMDBTools = IntegrationToolsData.filter(
    (tool) =>
        tool.category?.includes("CMDB") || tool.category === "CMDB" ||
        tool.category?.includes("Developer Portal") || tool.category === "Developer Portal",
);

export const APISupportedSecurityTools = SecurityToolsData.filter(toolConfig => {
    if(toolConfig.ConfigComponent){
        try {
            const children = toolConfig.ConfigComponent({});
            return !!children?.props?.PullCredentialForm;
        } catch (e) {
            // Some ConfigComponents use hooks and can't be called as functions
            return false;
        }
    }
    return false;
});

export const AutoMappingSupportedTools = [
    "Snyk",
    "Checkmarx",
    "Dependabot",
    "Github Code Scan",
    "Github Secret Scan",
    "Fortify",
    "Mend",
    "Semgrep",
    "Blackduck Hub",
    "Gitlab Security",
    "Sonarcloud",
    "Checkmarx One",
    "Checkmarx SCA",
    "Mend.io",
    "SonarQube",
    "Cycode",
    "Veracode",
    "Orca Security Shiftleft"
];

export const RBVM_CATEGORIES = [
  "Infrastructure Tools",
  "CSPM",
  "Container Security",
  "External Attack Surface Management",
  "Pentesting Framework",
  "CNAPP",
  "TPRM",
  "Endpoint Vulnerability Management",
];


const ToolIconMap = {};
SecurityToolsData.forEach((t) => {
    ToolIconMap[t.name] = t.icon;
    ToolIconMap[t.displayName] = t.icon;
});

export { ToolIconMap }